import Aegis from '@tencent/aegis-web-sdk-v2';
import { isNil } from 'lodash';
import Cookies from 'universal-cookie';

import { CgiErrorCode, PIC_CODE_END, PIC_CODE_START } from '@/services/cgi';
import { isProd, isWoa } from '@/utils/getApiDomain';

import { LogType, shouldIgnoreLog } from './tam';


// 子域名
const cookies = new Cookies(null, { path: '/', domain: '.dreamai.fun' });

const url = 'https://galileotelemetry.tencent.com/collect'; // 伽利略上报地址，不变
const testTamV2SdkId = 'SDK-c9ae495f6e622c8d8201';
const prodTamV2SdkId = 'SDK-350d9d83a0cf4ebe0746';

export const developmentISLocal = process.env.NODE_ENV === 'local';


export const replayId = isProd && !developmentISLocal ? prodTamV2SdkId : testTamV2SdkId; // 项目token

export const getUserId = () => cookies.get('vuserid') || cookies.get('vuser');;

const vuid = getUserId();

export let aegisV2: Aegis | null = null;


const initConfig = () => {
  aegisV2 = aegisV2 ? aegisV2 : new Aegis({
    id: replayId, // 项目token，即上报伽利略监控的唯一标识
    uid: `${vuid}`,
    hostUrl: { url },
    onBeforeSend: (logs: { level: string; msg: string, url: string, data: string }[]) => {
      const result = logs?.map((log) => {
        const { level, msg } = log;
        if (shouldIgnoreLog(level as LogType, msg)) {
          return false;
        }
        return log;
      });
      return result?.filter(log => log);
    },
    plugin: {
      device: true, // 默认开启device收集器
      close: true, // 默认开启close收集器
      aid: true, // 默认开启aid收集器
      fId: false, // 默认关闭fingerId
      ie: false, // 默认关闭ie收集器

      // 页面访问
      pv: true, // 默认开启pv收集器
      spa: true, // 默认开启spa收集器

      // 勾选异常分析
      error: true, // 默认开启error收集器

      // 勾选静态资源监控
      assetSpeed: true, // 默认开启assetSpeed收集器

      // 勾选页面性能
      pagePerformance: true, // 默认开启pagePerformance收集器
      webVitals: true, // 默认开启webVitals收集器

      // 勾选session功能
      session: true,

      // 同时勾选api和trace或者仅勾选trace
      api: {
        apiDetail: true,
        resourceTypeHandler: (url: string) => {
          const resourceTypeExtensions = ['.atlas', '.skel.bytes', '.bytes', '.atlas.txt', '.skel'];
          if (resourceTypeExtensions.some(ext => url?.includes(ext))) {
            return 'static';
          }
        },
        retCodeHandler(ret: string) {
          let isError = true;
          let code;
          try {
            const retObj = JSON.parse(ret || '{}');
            code = retObj.code || retObj.ret;
            // 符合预期的codes
            const expectedCodes = [
              CgiErrorCode.NO_ERROR,
              CgiErrorCode.MoveMaterialPartialFail,
              CgiErrorCode.ValidateError,
              CgiErrorCode.NOT_EXIST,
              CgiErrorCode.NotLogin,
              CgiErrorCode.NotBindPhone,
              CgiErrorCode.NotQQLogin,
              CgiErrorCode.UniNotLogin,
              CgiErrorCode.TrpcNtLogin,
              CgiErrorCode.ErrLogin,
              CgiErrorCode.NeedRefresh,
              CgiErrorCode.VersionError,
              CgiErrorCode.MoveMaterialAllFail,
              CgiErrorCode.BlackUser,
              CgiErrorCode.UsageExceed,
              CgiErrorCode.SomeDataIsNull,
              CgiErrorCode.SomeDataIncorrect,
              CgiErrorCode.NoPermission,
              CgiErrorCode.DeleteStageFail,
              CgiErrorCode.DeleteChapterFail,
              CgiErrorCode.DeleteStoryFail,
              CgiErrorCode.DeleteRoleFail,
              CgiErrorCode.Illegal,
            ];
            if (
              isNil(code)
              || code === 0
              || code === '0'
              || expectedCodes?.includes(code)
              || (code >= PIC_CODE_START && code <= PIC_CODE_END)
            ) {
              isError = false;
            }
          } catch (e) {
            isError = true;
            code = `parse error:${ret}`;
          }
          return { isErr: isError, code };
        },
      },
    },
  });
  return aegisV2;
};

export const reportInitV2 = () => {
  if (isWoa || developmentISLocal) return;

  initConfig();

  if (!aegisV2) return;

  aegisV2.setConfig({
    uid: `${vuid}`,
  });
};
